import { useMemo, useState, type PropsWithChildren } from "react";

import {
  HotelDataContext,
  type HotelDataContextValue,
} from "./HotelDataContext";

export const HotelDataProvider = ({ children }: PropsWithChildren) => {
  const [data, setData] = useState<HotelDataContextValue["data"]>(null);

  const contextValue = useMemo(
    () => ({
      data,
      setData,
    }),
    [data],
  );

  return (
    <HotelDataContext.Provider value={contextValue}>
      {children}
    </HotelDataContext.Provider>
  );
};
